import { MessagePrefix } from '@klarna-web-sdk/messaging/src/types'

export const isValidMessagePrefix = (messagePrefix: string): boolean => {
  const supportedMessagePrefix: MessagePrefix[] = ['Or', 'or', '']
  return supportedMessagePrefix.includes(messagePrefix as MessagePrefix)
}
